// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingCancellationPanel_root__3EziL","form":"EditListingCancellationPanel_form__2bCeE","title":"EditListingCancellationPanel_title__2EzjL"};